import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormFieldBaseComponent } from '../form-field-base/form-field-base.component';
import { CoreComponentService } from '@app/core/services/core-component.service';
import { LayoutService } from '@app/core/services/layout.service';
import { TranslateService } from '@app/core/services/translate.service';
import { RememberService } from '@app/core/services/remember.service';
import { UtilityService } from '@app/core/services/utility.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from '@app/core/services/toast.service';
import { ModalService } from '@app/core/services/modal.service';

@Component({
    selector: 'tt-input-signature',
    templateUrl: './input-signature.component.html',
    styleUrls: ['./input-signature.component.css'],
})
export class InputSignatureComponent extends FormFieldBaseComponent implements OnInit, OnChanges {
    /**
     * The model of the input field.
     */
    @Input()
    ttModel: string = '';

    /**
     * The data format of the signature image.
     */
    @Input()
    ttDataFormat: string = '';

    /**
     * Event emitted when the model value changes from the component, $event is the new ttModel value.
     */
    @Output()
    ttModelChange = new EventEmitter<string>();

    constructor(
        layout: LayoutService,
        core: CoreComponentService,
        translate: TranslateService,
        remember: RememberService,
        utility: UtilityService,
        dialog: MatDialog,
        toast: ToastService,
        private modal: ModalService,
    ) {
        super(layout, core, translate, remember, utility, dialog, toast);
    }

    public onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.openSignatureDialog();
        }
    }

    public async openSignatureDialog() {
        if (this.ttDisabled || this.ttReadonly) return;

        const response = await this.modal.openSignaturePadDialog(this.ttModel, this.ttDataFormat);

        if (response !== undefined) {
            this.ttModel = response;
            this.ttModelChange.emit(this.ttModel);
        }
    }

    override async ngOnChanges(changes: SimpleChanges): Promise<void> {
        super.ngOnChanges(changes);
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }
}
